import dayjs from 'dayjs';

interface TemplateAnalytics {
  id: string;
  name: string;
  format: string;
  totalUses: number;
  lastUsedAt: string | null;
}

export const exportTemplateAnalyticsToCsv = (
  templates: TemplateAnalytics[],
  teamId: string,
  dateRange: string
): void => {
  // Prepare headers
  const headers = ['Template Name', 'Format', 'Total Uses', 'Last Used'];
  
  // Prepare rows
  const rows = templates.map(template => [
    template.name,
    formatDisplayName(template.format),
    template.totalUses.toString(),
    template.lastUsedAt ? dayjs(template.lastUsedAt).format('YYYY-MM-DD HH:mm:ss') : 'Never',
  ]);
  
  // Add metadata rows at the top
  const metadata = [
    [`Template Analytics Report`],
    [`Team ID: ${teamId}`],
    [`Date Range: ${dateRange}`],
    [`Generated: ${dayjs().format('YYYY-MM-DD HH:mm:ss')}`],
    [], // Empty row for spacing
  ];
  
  // Combine all data
  const csvContent = [
    ...metadata,
    headers,
    ...rows,
  ]
    .map(row => row.map(cell => escapeCSVCell(cell)).join(','))
    .join('\n');
  
  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.href = url;
  link.download = `template-analytics-${dateRange}.csv`;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up
  window.URL.revokeObjectURL(url);
};

const formatDisplayName = (format: string): string => {
  switch (format) {
    case 'pdf':
      return 'PDF';
    case 'fully_editable':
      return 'Fully Editable';
    case 'restricted':
      return 'Restricted';
    default:
      return format;
  }
};

const escapeCSVCell = (cell: string): string => {
  // If cell contains comma, quotes, or newline, wrap in quotes and escape existing quotes
  if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
    return `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
};